// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__iNQip","list":"styles_list__3zN3C"};